module.exports = __webpack_public_path__ + "img/suggest.2aab7adc.svg";